import { Select } from "antd";

import React from "react";

export const FilterDropDownList = ({ dataList, label, onClick }) => {
  return (
    <div>
      <Select
        placeholder={"Select an option..."}
        className="dashboard_filter_select"
        size="large"
        style={{ textAlign: "left" }}
        // allowClear
        defaultValue={label}
        // bordered={true}
        onChange={(value) => onClick(value)}
        options={dataList}
        showSearch
      />
    </div>
  );
};
